import { render, staticRenderFns } from "./SurveyConclusion.vue?vue&type=template&id=370cc9b9&scoped=true&"
import script from "./SurveyConclusion.vue?vue&type=script&lang=js&"
export * from "./SurveyConclusion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyConclusion.vue?vue&type=style&index=0&id=370cc9b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cc9b9",
  null
  
)

export default component.exports